import {
  AssignmentLateOutlined,
  AssignmentOutlined,
  InfoOutlined,
  VideoLibraryOutlined,
} from "@mui/icons-material";
import ViewHeadlineIcon from "@mui/icons-material/ViewHeadline";
import { Divider, ListItemText, MenuItem, Tooltip } from "@mui/material";
import React from "react";
import { Link } from "react-router-dom";
import { StyledHeader } from "../../styled/layout";
import AboutDialog from "../about/about";
import PrivacyPoliciesDialog from "../termsConditions/privacyPolicies";
import TermsConditionsDialog from "../termsConditions/termsConditions";

const IconMenuHelp = () => {
  const [openAbout, setOpenAbout] = React.useState(false);
  const [openMenu, setOpenMenu] = React.useState(null);
  const [openTerms, setOpenTerms] = React.useState(false);
  const [openPrivacy, setOpenPrivacy] = React.useState(false);

  const handleClickGuide = () => {
    setOpenMenu(null);
  };

  const handleClickAbout = () => {
    setOpenMenu(null);
    setOpenAbout(true);
  };

  const handleClickTermns = () => {
    setOpenMenu(null);
    setOpenTerms(true);
  };

  const handleClickPrivacy = () => {
    setOpenMenu(null);
    setOpenPrivacy(true);
  };

  const handleClose = (event) => {
    setOpenAbout(false);
    setOpenMenu(null);
    setOpenTerms(false);
    setOpenPrivacy(false);
  };

  const handleClickMenu = (event) => {
    setOpenMenu(event.currentTarget);
  };

  return (
    <React.Fragment>
      <StyledHeader.OptionsIconContainer>
        <Tooltip title="Opciones" arrow>
          <StyledHeader.HeaderIcon size="small" onClick={handleClickMenu}>
            <ViewHeadlineIcon />
          </StyledHeader.HeaderIcon>
        </Tooltip>
      </StyledHeader.OptionsIconContainer>
      <StyledHeader.Menu
        id="simple-menu"
        anchorEl={openMenu}
        keepMounted
        open={Boolean(openMenu)}
        onClose={handleClose}>
        <MenuItem onClick={handleClickGuide} component={Link} to="/tutorials">
          <StyledHeader.MenuItem size="small">
            <VideoLibraryOutlined />
          </StyledHeader.MenuItem>
          <ListItemText primary="Guías de Usuario" />
        </MenuItem>
        <Divider variant="middle" />
        <MenuItem onClick={handleClickTermns}>
          <StyledHeader.MenuItem size="small">
            <AssignmentOutlined />
          </StyledHeader.MenuItem>
          <ListItemText primary="Términos y Condiciones" />
        </MenuItem>
        <MenuItem onClick={handleClickPrivacy}>
          <StyledHeader.MenuItem size="small">
            <AssignmentLateOutlined />
          </StyledHeader.MenuItem>
          <ListItemText primary="Políticas de Privacidad y Confidencialidad" />
        </MenuItem>
        <Divider variant="middle" />
        <MenuItem onClick={handleClickAbout}>
          <StyledHeader.MenuItem size="small">
            <InfoOutlined />
          </StyledHeader.MenuItem>
          <ListItemText primary="Acerca de..." />
        </MenuItem>
      </StyledHeader.Menu>
      <AboutDialog open={openAbout} onClose={handleClose} />
      <TermsConditionsDialog open={openTerms} onClose={handleClose} />
      <PrivacyPoliciesDialog open={openPrivacy} onClose={handleClose} />
    </React.Fragment>
  );
};

export default IconMenuHelp;
